import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import AnnouncementsModalContainer from './AnnouncementsModalContainer';

import AnnouncementsComponent from './AnnouncementsListComponent';

import { getBuildingsForFilter } from '../Building/actionCreators';
import { showRenderPropsModal } from '../Modal/actions';
import {
  deleteAnnouncement,
  getAnnouncements,
  sendAnnouncement,
} from './actions';

import { filterObjectByKeyValue, getTodayCount, isAdmin } from '../../utils';

import * as commonSelectors from '../Shared/selectors';

const LIST_KEY = 'announcements';

const AnnouncementsListContainer = (props) => {
  const { t } = useTransl();
  const {
    onGetAnnouncements,
    onDeleteAnnouncement,
    onSendAnnouncement,
    openAnnouncementsModal,
    listParams,
    getItems,
  } = props;

  if (!isAdmin()) return null;

  const onAnnouncementsExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetAnnouncements(queryParams);
  };

  const getModalProps = (announcementsData) => ({
    title: t('title.popupMessage'),
    maxWidth: 'md',
    render: (props) => (
      <AnnouncementsModalContainer
        {...props}
        listParams={listParams}
        getAnnouncements={getItems}
        announcementsData={announcementsData}
      />
    ),
  });

  const onOpenAnnouncementsModal = (announcementsData) => {
    const modalProps = getModalProps(announcementsData);
    openAnnouncementsModal(modalProps);
  };

  const onAnnouncementDelete = async (id) => {
    await onDeleteAnnouncement(id);
    getItems(listParams);
  };

  const onAnnouncementSend = async (id) => {
    await onSendAnnouncement(id);
    getItems(listParams);
  };

  return (
    <AnnouncementsComponent
      {...props}
      openAnnouncementsModal={onOpenAnnouncementsModal}
      onAnnouncementsExport={onAnnouncementsExport}
      onDelete={onAnnouncementDelete}
      onSend={onAnnouncementSend}
    />
  );
};

AnnouncementsListContainer.propTypes = {
  onGetAnnouncements: PropTypes.func.isRequired,
  onDeleteAnnouncement: PropTypes.func.isRequired,
  onSendAnnouncement: PropTypes.func.isRequired,
  openAnnouncementsModal: PropTypes.func.isRequired,
  getItems: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { pmcs, buildings, announcements } = state;
  const pmcId = commonSelectors.getPmcId(ownProps);
  const buildingId = commonSelectors.getBuildingId(ownProps);
  const listParams = commonSelectors.getListParams(state, LIST_KEY);

  const pmc = pmcId && pmcs?.[pmcId];
  const building = buildingId && buildings?.[buildingId];

  return {
    pmcId,
    buildingId,
    pmc,
    building,
    listKey: LIST_KEY,
    listParams,
    items: announcements,
    buildings: pmcId
      ? filterObjectByKeyValue(buildings, 'parent.id', +pmcId)
      : buildings,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const buildingId = commonSelectors.getBuildingId(ownProps);
  return {
    onLoad: (params) => {
      !buildingId && getBuildingsForFilter(dispatch, params);
    },
    getItems: (queryParams) => {
      getAnnouncements(dispatch, queryParams);
      return getTodayCount(getAnnouncements, dispatch, queryParams);
    },
    onGetAnnouncements: (queryParams) =>
      getAnnouncements(dispatch, queryParams, true),
    openAnnouncementsModal: (modalProps) =>
      showRenderPropsModal(dispatch, modalProps),
    onDeleteAnnouncement: (id) => deleteAnnouncement(dispatch, id),
    onSendAnnouncement: (id) => sendAnnouncement(dispatch, id),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AnnouncementsListContainer);
